export default __webpack_public_path__ + "media/images/add_table-caac42cba31ff191765a9a8e33143c38.gif";